import { getMinPriceFromUrl, getMaxPriceFromUrl } from './queryStringHelpers';

export interface BudgetFilters {
  minPrice: string;
  maxPrice: string;
}

export const getBudgetFiltersFromUrl = (url: string): BudgetFilters => {
  return {
    minPrice: getMinPriceFromUrl(url),
    maxPrice: getMaxPriceFromUrl(url),
  };
};
